import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RentalProduct, RentalProductState } from "./rental-product.interface";
import { defaultApiState } from "../../../common/constants/api-constants";
import { StoreState } from "../../../store/store.interface";
import { ActionStatus } from "../../../common/constants/action-status";
import environment from "../../../common/environment";
import { getResponseData } from "../../../common/utils/api-utils";

export const rentalProductInitialState: RentalProductState = defaultApiState;


// CREATE SELECTOR
export const getRentalIsbn13 = (state: StoreState) => {
    const rentalProduct = state.rentalProductState;
    if(rentalProduct.status == ActionStatus.succeeded && rentalProduct.data?.length){
        return rentalProduct.data[0].rentalIsbn13;
    }
    return '';
}


// CREATE STORE SLICE
export const rentalProductSlice = createSlice({
    name: "rentalProduct",
    initialState: rentalProductInitialState,
    reducers:{},
    extraReducers(builder) {
      builder
      .addCase(getRentalProduct.pending, (state) => {
        state.status = ActionStatus.loading;
      })
      .addCase(getRentalProduct.fulfilled, (state, action) => {
        state.status = ActionStatus.succeeded;
        state.data = action.payload;
      })
      .addCase(getRentalProduct.rejected, (state, action) => {
        state.status = ActionStatus.failed;
        state.error = action.error.message || '';
      })
    }
});


// CREATE REDUCER
export const rentalProductReducer = rentalProductSlice.reducer;


// DECLARE THUNKS
export const getRentalProduct = createAsyncThunk('orderCompletion/getRentalProduct', async (isbn10: any, thunkAPI) => {
    try {
        if (isbn10) {
            return await getRentalProductApiCall(isbn10);
        } else {
            return thunkAPI.rejectWithValue({
                message: 'Missing isbn10.',
                isbn10: isbn10
            });
        }
    } catch (error) {
        return thunkAPI.rejectWithValue({
            error: error,
            isbn10: isbn10
        })
    }
}, {
    condition: ((_args: any, { getState }) => {
        const state = getState() as StoreState;
        return state.rentalProductState.status === ActionStatus.idle;
    })
});


// MAKE API CALL
async function getRentalProductApiCall(isbn10: string): Promise<RentalProduct[]> {
    const url = new URL(`${environment().searchServiceUrl}/rental/product/${isbn10}`);
    return await getResponseData(
        new Request(url.toString(), {
            method: 'GET',
            headers: {'Content-Type': 'application/json'}
        })
    );
}